export default __webpack_public_path__ + "static/media/benefits@3x.f608cc69.png";